var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.medal == 1)?_c('IconCompMedal',{attrs:{"size":_vm.iconSize,"color":_vm.themeColor('gold')}}):(_vm.medal == 2)?_c('IconCompMedal',{attrs:{"size":_vm.iconSize,"color":_vm.themeColor('silver')}}):(_vm.medal == 3)?_c('IconCompMedal',{attrs:{"size":_vm.iconSize,"color":_vm.themeColor('bronze')}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }